export class ResizableElement
{
  constructor(containerSelector, headerSelector, handleSelector)
  {
    this.containerSelector = containerSelector || '.camera-stream-window';
    this.headerSelector = headerSelector || '.camera-stream-window__header';
    this.handleSelector = handleSelector || '.camera-stream-resize-handle';
  }

  start()
  {
    const container = document.querySelector(this.containerSelector);
    const header = document.querySelector(this.headerSelector);
    const resizeHandles = document.querySelectorAll(this.handleSelector);

    if (!container || !header)
    {
      console.warn('[ResizableElement] DOM elements not found, skipping initialization');
      return;
    }

    let isDragging = false;
    let isResizing = false;
    let currentHandle = null;
    let startX = 0;
    let startY = 0;
    let startWidth = 0;
    let startHeight = 0;
    let startLeft = 0;
    let startTop = 0;

    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999999;
      display: none;
      background: transparent;
    `;
    document.body.appendChild(overlay);

    function drag(e)
    {
      if (!isDragging) return;

      const newLeft = e.clientX - startX;
      const newTop = e.clientY - startY;

      const maxLeft = window.innerWidth - container.offsetWidth;
      const maxTop = window.innerHeight - container.offsetHeight;

      container.style.left = Math.max(0, Math.min(maxLeft, newLeft)) + 'px';
      container.style.top = Math.max(0, Math.min(maxTop, newTop)) + 'px';
      container.style.right = 'auto';
    }

    function stopDrag()
    {
      if (!isDragging) return;
      isDragging = false;

      overlay.style.display = 'none';
      overlay.removeEventListener('mousemove', drag);
      overlay.removeEventListener('mouseup', stopDrag);
      overlay.removeEventListener('mouseleave', stopDrag);

      document.body.style.userSelect = '';
    }

    function startDrag(e)
    {
      if (isResizing) return;
      if (e.target.closest('.camera-stream-window__header-close, [data-no-drag], button, a, input, select, textarea')) return;
      isDragging = true;
      startX = e.clientX - container.offsetLeft;
      startY = e.clientY - container.offsetTop;

      overlay.style.display = 'block';
      overlay.style.cursor = 'move';

      overlay.addEventListener('mousemove', drag);
      overlay.addEventListener('mouseup', stopDrag);
      overlay.addEventListener('mouseleave', stopDrag);

      e.preventDefault();
      e.stopPropagation();

      document.body.style.userSelect = 'none';
    }

    header.addEventListener('mousedown', startDrag);

    function resize(e)
    {
      if (!isResizing) return;

      const deltaX = e.clientX - startX;
      const deltaY = e.clientY - startY;

      let newWidth = startWidth;
      let newHeight = startHeight;
      let newLeft = startLeft;
      let newTop = startTop;

      if (currentHandle.includes('e'))
      {
        newWidth = Math.max(300, startWidth + deltaX);
      }
      if (currentHandle.includes('w'))
      {
        newWidth = Math.max(300, startWidth - deltaX);
        newLeft = startLeft + (startWidth - newWidth);
      }
      if (currentHandle.includes('s'))
      {
        newHeight = Math.max(200, startHeight + deltaY);
      }
      if (currentHandle.includes('n'))
      {
        newHeight = Math.max(200, startHeight - deltaY);
        newTop = startTop + (startHeight - newHeight);
      }

      const maxWidth = window.innerWidth - newLeft;
      const maxHeight = window.innerHeight - newTop;

      newWidth = Math.min(newWidth, Math.max(300, maxWidth));
      newHeight = Math.min(newHeight, Math.max(200, maxHeight));

      container.style.width = newWidth + 'px';
      container.style.height = newHeight + 'px';
      container.style.left = Math.max(0, newLeft) + 'px';
      container.style.top = Math.max(0, newTop) + 'px';
      container.style.right = 'auto';
    }

    function stopResize()
    {
      if (!isResizing) return;
      isResizing = false;
      currentHandle = null;

      overlay.style.display = 'none';
      overlay.removeEventListener('mousemove', resize);
      overlay.removeEventListener('mouseup', stopResize);
      overlay.removeEventListener('mouseleave', stopResize);

      document.body.style.userSelect = '';
    }

    function startResize(e)
    {
      if (isDragging) return;
      isResizing = true;
      currentHandle = e.target.dataset.direction;
      startX = e.clientX;
      startY = e.clientY;
      startWidth = parseInt(window.getComputedStyle(container).width, 10);
      startHeight = parseInt(window.getComputedStyle(container).height, 10);
      startLeft = container.offsetLeft;
      startTop = container.offsetTop;

      overlay.style.display = 'block';
      overlay.style.cursor = window.getComputedStyle(e.target).cursor;

      overlay.addEventListener('mousemove', resize);
      overlay.addEventListener('mouseup', stopResize);
      overlay.addEventListener('mouseleave', stopResize);

      e.preventDefault();
      e.stopPropagation();

      document.body.style.userSelect = 'none';
    }

    resizeHandles.forEach(handle =>
    {
      handle.addEventListener('mousedown', startResize);
    });

    document.addEventListener('selectstart', function(e)
    {
      if (isDragging || isResizing)
      {
        e.preventDefault();
      }
    });

    document.addEventListener('keydown', function(e)
    {
      if (e.key === 'Escape')
      {
        if (isDragging) stopDrag();
        if (isResizing) stopResize();
      }
    });
  }
}
